function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 4.82,
  d: "M9.59 61.3h44.82L52.8 19.16H11.2L9.59 61.3zM20.94 14.45a11.87 11.87 0 0123.74 0"
});

function SvgBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij48dGl0bGU+YmFnPC90aXRsZT48cG9seWdvbiBwb2ludHM9IjkuNTkgNjEuMyA1NC40MSA2MS4zIDUyLjggMTkuMTYgMTEuMiAxOS4xNiA5LjU5IDYxLjMiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iNC44MiIvPjxwYXRoIGQ9Ik0yMC45NCwxNC40NWExMS44NywxMS44NywwLDAsMSwyMy43NCwwIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjQuODIiLz48L3N2Zz4=";
export { SvgBag as ReactComponent };